import { useCallback, useEffect, useRef, useState } from "react";
function useNodeInteraction({ isCreateNode, isRenaming, title, searchSelected, expanded, id, icon, childNodes = [], classNameProp, onAddClose, onRenameClose, onSelect, onExpand, onCheck, onNodePressF2 }) {
    const [inputValue, setInputValue] = useState("");
    const [initialInputValue, setInitialInputValue] = useState(false);
    const refNode = useRef(null);
    const scrollTo = useCallback(()=>{
        refNode.current?.scrollIntoView({
            block: "nearest",
            inline: "nearest"
        });
    }, []);
    useEffect(()=>{
        searchSelected && scrollTo();
        if (isCreateNode) {
            return;
        }
        if (inputValue !== title && isRenaming && !initialInputValue) {
            setInputValue(title);
            setInitialInputValue(true);
        } else if (!isRenaming && initialInputValue) {
            setInputValue("");
            setInitialInputValue(false);
        }
    }, [
        isCreateNode,
        initialInputValue,
        inputValue,
        isRenaming,
        scrollTo,
        searchSelected,
        title
    ]);
    const handleRef = useCallback((node)=>{
        refNode.current = node;
        isCreateNode && scrollTo();
    }, [
        isCreateNode,
        scrollTo
    ]);
    const handleButtonSave = (save = true)=>{
        const shouldSave = typeof save === "boolean" ? save : true;
        if (shouldSave && !inputValue) {
            return;
        }
        const nodeProps = {
            id,
            title,
            icon,
            childNodes,
            className: classNameProp
        };
        const closeHandler = isCreateNode ? onAddClose ?? onRenameClose : onRenameClose;
        closeHandler?.(shouldSave, inputValue, nodeProps);
    };
    const handleInputKeyDown = (event)=>{
        if (event.key === "Enter") {
            handleButtonSave(true);
        } else if (event.key === "Escape") {
            handleButtonSave(false);
        }
    };
    const handleNodeKeyDown = (event)=>{
        if (event.key === "F2" && !isRenaming) {
            onNodePressF2?.({
                id,
                title,
                icon,
                childNodes,
                className: classNameProp
            });
        }
    };
    const handleInputChange = (event)=>setInputValue(event.target.value);
    const handleSelect = (event)=>{
        const target = event.target;
        if (!target.closest(".aiot-disable-links") && !target.closest('[class*="-checkbox-wrapper"]')) {
            id !== undefined && onSelect?.(id);
        }
    };
    const handleToggle = (event)=>{
        onExpand?.(!expanded, {
            id,
            title,
            icon,
            childNodes,
            className: classNameProp
        });
        event.preventDefault();
    };
    const handleCheck = ()=>{
        id !== undefined && onCheck?.(id);
    };
    return {
        inputValue,
        handleRef,
        handleButtonSave,
        handleInputKeyDown,
        handleNodeKeyDown,
        handleInputChange,
        handleSelect,
        handleToggle,
        handleCheck
    };
}
export { useNodeInteraction };
